import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../services/common/common.service';
import { Router } from '@angular/router';
import { LoginLabelConstants } from '../../constants/label-constants';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { StorageService } from '../../services/storage/storage.service';
import { loginModel } from '../../models/authentication/login-model';
import { SharedService } from '../../services/shared-service/shared.service';
import { CookieService } from 'ngx-cookie-service';
import { StateService } from '../../services/common/claim-year.service';
import { UserService } from '../../services/user-service/user.service';
import { CommonErrorMessages } from '../../constants/error-messages';
import { PrivacyLegalDialogComponent } from '../privacy-legal-dialog/privacy-legal-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})

export class LoginComponent implements OnInit {

  cookieEmail: string = '';
  cookiePassword: string = '';
  loginForm: FormGroup | any;
  submitted: boolean = false;
  labelConstants: any;
  errorConstants: any;
  isShowPassword: boolean = false;
  loginReqModel: loginModel;
  isLoading: boolean = false;
  fullUrl!: string;
  currentYear: number = new Date().getFullYear();;
  IsShowCapcha: boolean = false;
  viewVerificationCode:boolean = false;
  verificationResponse = {
    EmailId : '',
    EncryptedOtp : '',
    Password : ''
  };

  constructor(
    private readonly fb: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly toastr: ToastrService,
    private readonly commonService: CommonService,
    private readonly router: Router,
    private readonly api: ApiUrlHelper,
    private readonly storageService: StorageService,
    private readonly sharedService: SharedService,
    private readonly cookieService: CookieService,
    private readonly sharedDataService: StateService,
    private readonly userService: UserService,
    private dialog: MatDialog

  ) {
    this.loginReqModel = new loginModel();
  }

  ngOnInit(): void {
    this.sharedService.setData('Login');
    this.fullUrl = window.location.href;
    if (this.fullUrl.includes('localhost')) {
      this.IsShowCapcha = false;
    } else {
      this.IsShowCapcha = true;
    }
    this.labelConstants = LoginLabelConstants;
    this.errorConstants = CommonErrorMessages;

    if (!this.IsShowCapcha) {
      this.loginForm = this.fb.group({
        UserEmail: [
          '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(
              /^(?=.{1,30}@)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            ),
          ],
        ],
        UserPassword: ['', [Validators.required]],
        recaptcha: [null],
        rememberMe: [false]
      });
    } else {
      this.loginForm = this.fb.group({
        UserEmail: [
          '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(
              /^(?=.{1,30}@)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            ),
          ],
        ],
        UserPassword: ['', [Validators.required]],
        recaptcha: [null, [Validators.required]],
        rememberMe: [false]
      });
    }
    if (localStorage.getItem('authToken')) {
      this.router.navigate(['/dashboard']);
    }
    this.fetchData();
  }

  get loginFormControls() {
    return this.loginForm?.controls;
  }

  submitLoginForm() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this.setLoadingState(true);
      this.submitted = false;
      this.spinner.show();

      this.loginReqModel.password = this.loginForm.value.UserPassword;
      this.loginReqModel.emailId = this.loginForm.value.UserEmail;
      this.verificationResponse.EmailId = this.loginReqModel.emailId;
      this.verificationResponse.Password = this.loginReqModel.password;
      let apiUrl = this.api.apiUrl.Login.UserLogin;
      localStorage.clear();

      this.commonService.doPost(apiUrl, this.loginReqModel).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            this.verificationResponse.EncryptedOtp = response.data;
            this.viewVerificationCode = true;
            this.setLoadingState(false);
            this.spinner.hide();
            this.setLoadingState(false);
          } else {
            this.setLoadingState(false);
            this.spinner.hide();
            this.toastr.error(response.message);
          }
        },
        error: (err) => {
          this.setLoadingState(false);
          this.spinner.hide();
        },
      });
    }
  }

  openDialog(type: string): void {
    const dialogConfig = {
      width: '800px',
      data: { type }, // Pass the type to the dialog
    };
    this.dialog.open(PrivacyLegalDialogComponent, dialogConfig);
  }

  onForgotPassword() {
    this.router.navigate(['forgot-password']);
  }

  togglePasswordVisibility() {
    this.isShowPassword = !this.isShowPassword;
  }

  setLoadingState(isLoading: boolean) {
    this.isLoading = isLoading;
    if (isLoading) {
      this.loginForm.disable();
    } else {
      this.loginForm.enable();
    }
  }

  fetchData() {
    const cookierememberMe  = this.cookieService.get("rememberMe");
    const cookieemail = this.cookieService.get('emailId');
    const cookiepassword = this.cookieService.get('password');
    if (cookierememberMe == 'yes') {
      this.loginFormControls['rememberMe'].setValue(true);
      this.loginFormControls['UserEmail'].setValue(cookieemail);
      this.loginFormControls['UserPassword'].setValue(cookiepassword);
      this.cookieEmail = cookieemail;
      this.cookiePassword = cookiepassword;
    }
    else {
      this.loginFormControls['UserEmail'].setValue('');
      this.loginFormControls['UserPassword'].setValue('');
      this.loginFormControls['rememberMe'].setValue(false);
    }
  }

  goLogin(){
    this.viewVerificationCode = false;
  }
}
